import smoothscroll from 'smoothscroll-polyfill';
import YubinBango from 'yubinbango.js';
smoothscroll.polyfill();

const siteNav = document.querySelector('.site-nav');
const siteNavContainer = siteNav.querySelector('.site-nav__container');
const inPageLinks = document.querySelectorAll('.in-page-link');

siteNav.addEventListener('click', () => {
	document.body.classList.remove('show-menu');
});

siteNavContainer.addEventListener('click', (e) => {
	e.stopPropagation();
});

for (let i = 0; i < inPageLinks.length; i++) {
	inPageLinks[i].addEventListener('click', (e) => {
		e.preventDefault();

		const targetID = e.target.hash;

		let scrollOffset = 0;

		if (window.innerWidth < 740) {
			switch (targetID) {
				case '#faqs':
					scrollOffset = 48;
					break;
				case '#inquiry':
					scrollOffset = 48;
					break;
				default:
					scrollOffset = 130;
			}
		}
		// if (window.innerWidth > 740 && window.innerWidth < 980) {
		// 	scrollOffset = targetID !== '#buy-rent-example' ? 200 : 100;
		// } else if (window.innerWidth > 980) {
		// 	scrollOffset = 0;
		// }

		const targetEl = document.querySelector(targetID);
		const targetPosition = targetEl.offsetTop - scrollOffset;

		window.scroll({
			top: targetPosition,
			left: 0,
			behavior: 'smooth'
		});

		setTimeout(() => {
			document.body.classList.remove('show-menu');
		}, 300);
	});
}

const menuTrigger = document.querySelector('.menu-trigger');
menuTrigger.addEventListener('click', (e) => {
	e.preventDefault();
	document.body.classList.toggle('show-menu');
});

import Masonry from 'masonry-layout';
const cvList = document.querySelector('.customer-voice-list');

const msnry = new Masonry(cvList, {
	itemSelector: '.cv-item',
	columnWidth: '.cv-item'
});

window.addEventListener('load', () => {
	setTimeout(() => {
		msnry.layout();
	}, 600);
});

let checkResize = null;
window.addEventListener('resize', () => {
	clearTimeout(checkResize);
	checkResize = setTimeout(() => {
		msnry.layout();
	}, 600);
});

const checkFloatButton = () => {
	const triggerPoint = document.querySelector('#buy-rent-example').offsetTop;
	const triggerPoint2 =
		document.querySelector('#inquiry').offsetTop -
		(window.innerHeight - 200);
	const scrollPosition = window.scrollY;

	if (scrollPosition >= triggerPoint && scrollPosition < triggerPoint2) {
		document.body.classList.add('show-float-button');
	} else {
		document.body.classList.remove('show-float-button');
	}
};

// window.addEventListener('scroll', () => {
// 	let scrollY = window.scrollY;

// 	setTimeout(() => {
// 		document.body.classList.remove('show-menu');
// 		if (scrollY > 100) {
// 			document.body.classList.add('header-bg');
// 		} else {
// 			document.body.classList.remove('header-bg');
// 		}
// 	}, 180);
// });

window.addEventListener('scroll', checkFloatButton);

const postalCodeInput = document.querySelector('input[name="postal-code"]');
const prefectureDropdown = document.querySelector('select[name="prefecture"]');
const cityInput = document.querySelector('input[name="city"]');

let errorDisplay = 0;
postalCodeInput.addEventListener('keyup', (e) => {
	const postalCode = e.target.value;

	if (postalCode === '') {
		errorDisplay = 0;
	}

	if (postalCode.length < 7) return;

	YubinBango.getAddress(postalCode)
		.then((res) => {
			const prefecture = res.prefecture;
			const locality = res.locality;
			const street = res.street;

			prefectureDropdown.value = prefecture;
			cityInput.value = `${locality}${street}`;
		})
		.catch((err) => {
			if (errorDisplay === 0) {
				alert('郵便番号は7桁にてご記入ください');
				errorDisplay = 1;
			}
		});
});
